import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.notion.comments');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const QUICK_EMOJIS = ['👍', '❤️', '😀', '🎉', '👀', '🤔'];

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-notion-comments',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.notion.comments/view.scss */
/* src/app/portal.lpsysadmin.widget.notion.comments/view.scss: no such file or directory */`],
})
export class PortalLpsysadminWidgetNotionCommentsComponent implements OnInit, OnChanges {
    @Input() noteId: string = '';
    @Input() noteType: string = 'company_comment';

    public comments: any[] = [];
    public newComment: string = '';
    public editingId: string = '';
    public editingContent: string = '';
    public replyingTo: string = '';
    public replyContent: string = '';
    public quickEmojis = QUICK_EMOJIS;
    public showEmojiForId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.noteId) await this.load();
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['noteId'] && !changes['noteId'].firstChange && this.noteId) {
            await this.load();
        }
    }

    public async load() {
        if (!this.noteId) return;
        const { code, data } = await wiz.call("search", {
            note_id: this.noteId,
            note_type: this.noteType,
        });
        if (code === 200) this.comments = data;
        await this.service.render();
    }

    /* ────────────────────────────────────────
       Top-level Comment
       ──────────────────────────────────────── */
    public async addComment() {
        const content = this.newComment.trim();
        if (!content) return;
        const { code } = await wiz.call("create", {
            note_id: this.noteId,
            note_type: this.noteType,
            content: content,
            parent_id: '',
        });
        if (code === 200) {
            this.newComment = '';
            await this.load();
        }
    }

    /* ────────────────────────────────────────
       Reply
       ──────────────────────────────────────── */
    public async startReply(commentId: string) {
        this.replyingTo = commentId;
        this.replyContent = '';
        await this.service.render();
    }

    public async cancelReply() {
        this.replyingTo = '';
        this.replyContent = '';
        await this.service.render();
    }

    public async submitReply(parentId: string) {
        const content = this.replyContent.trim();
        if (!content) return;
        const { code } = await wiz.call("create", {
            note_id: this.noteId,
            note_type: this.noteType,
            content: content,
            parent_id: parentId,
        });
        if (code === 200) {
            this.replyingTo = '';
            this.replyContent = '';
            await this.load();
        }
    }

    /* ────────────────────────────────────────
       Edit
       ──────────────────────────────────────── */
    public async startEdit(comment: any) {
        this.editingId = comment.id;
        this.editingContent = comment.content;
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingId = '';
        this.editingContent = '';
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.editingId || !this.editingContent.trim()) return;
        const { code } = await wiz.call("update", {
            id: this.editingId,
            content: this.editingContent.trim(),
        });
        if (code === 200) {
            this.editingId = '';
            this.editingContent = '';
            await this.load();
        }
    }

    /* ────────────────────────────────────────
       Delete
       ──────────────────────────────────────── */
    public async deleteComment(id: string) {
        const res = await this.service.alert.show({
            title: "",
            message: "댓글을 삭제하시겠습니까?",
            cancel: "취소",
            actionBtn: "error",
            action: "삭제",
            status: "error",
        });
        if (!res) return;
        await wiz.call("delete", { id });
        await this.load();
    }

    /* ────────────────────────────────────────
       Reactions
       ──────────────────────────────────────── */
    public async toggleEmoji(commentId: string) {
        this.showEmojiForId = this.showEmojiForId === commentId ? '' : commentId;
        await this.service.render();
    }

    public async react(commentId: string, emoji: string) {
        const { code, data } = await wiz.call("react", {
            id: commentId,
            emoji: emoji,
        });
        if (code === 200) {
            // Update in-place
            const comment = this.findComment(commentId);
            if (comment) comment.reactions = data.reactions || {};
            this.showEmojiForId = '';
            await this.service.render();
        }
    }

    private findComment(id: string): any {
        for (const c of this.comments) {
            if (c.id === id) return c;
            if (c.replies) {
                for (const r of c.replies) {
                    if (r.id === id) return r;
                }
            }
        }
        return null;
    }

    public getReactionEntries(reactions: any): any[] {
        if (!reactions || typeof reactions !== 'object') return [];
        return Object.entries(reactions).map(([emoji, users]: [string, any]) => ({
            emoji,
            count: Array.isArray(users) ? users.length : 0,
            active: Array.isArray(users) && users.includes(this.service.auth?.session?.id),
        }));
    }

    /* ────────────────────────────────────────
       Helpers
       ──────────────────────────────────────── */
    public isOwner(comment: any): boolean {
        const session = this.service.auth?.session || {};
        return comment.user_id === session.id;
    }

    public formatDate(date: string): string {
        if (!date) return '-';
        const d = date.substring(0, 16).replace('T', ' ');
        return d === 'Invalid date' ? '-' : d;
    }

    public isEdited(comment: any): boolean {
        return comment.updated && comment.created &&
            comment.updated.substring(0, 16) !== comment.created.substring(0, 16);
    }

    public handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.addComment();
        }
    }

    public handleReplyKeydown(event: KeyboardEvent, parentId: string) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.submitReply(parentId);
        }
    }
}

export default PortalLpsysadminWidgetNotionCommentsComponent;